//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { NAME_PREFIX } from './const';
import Heading from './components/heading.vue';
import LeftDesignBlock from './components/leftDesignBlock.vue';
import RightDesignBlock from './components/rightDesignBlock.vue';
import Badge from './components/badge.vue';
import Duration from './components/duration.vue';
import Btn from './components/btn.vue';
import CloseButton from './components/closeButton.vue';
import Bg from './components/bg.vue';

import { getEternalEndDate } from '../utils/getEternalEndDate';

import * as dayjs from 'dayjs';
import * as utc from 'dayjs/plugin/utc';
import * as duration from 'dayjs/plugin/duration';

dayjs.extend(utc);
dayjs.extend(duration);

export default {
  name: 'SharedSaleBlock',
  components: {
    Heading,
    LeftDesignBlock,
    RightDesignBlock,
    Badge,
    Duration,
    Btn,
    CloseButton,
    Bg,
  },
  props: {
    saleBlockData: {
      type: Object,
      required: true,
    },
    cookieName: {
      type: String,
      required: true,
    },
    isEmbedded: {
      type: Boolean,
      required: true,
    },
    isAnchorButton: {
      type: Boolean,
      default: true,
    },
    anchor: {
      type: String,
      default: '',
    },
    buttonLink: {
      type: String,
      default: '',
    },
    classes: {
      type: Object,
    },
    fontUpdateDate: {
      type: Date,
    },
    buttonText: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      saleClasses: [],
      duration: dayjs.duration(0, 'milliseconds', true),
    };
  },
  computed: {
    isVisible() {
      const duration = this.duration;

      return duration.$ms > 0;
    },
  },
  watch: {
    fontUpdateDate() {
      this.setSaleClasses();
    },
  },
  created() {
    this.setSaleClasses();
    this.setDuratuon();
  },
  mounted() {
    this.interval = setInterval(() => {
      this.setDuratuon();
    }, 1000);
  },
  beforeDestroy() {
    clearInterval(this.interval);
  },
  methods: {
    onCloseBanner(e) {
      this.$emit('onCloseBanner');
      e.stopPropagation();
      e.preventDefault();
    },
    onClick() {
      this.$emit('onClick');
    },
    getSaleClass() {
      return `${NAME_PREFIX}_${this.saleBlockData.slug}`;
    },
    getAllLoadedFonts() {
      const fonts = document.fonts;
      const fontsArray = [];

      fonts.forEach((fontFace) => {
        fontsArray.push(fontFace.family);
      });

      // converted to set then arr to filter repetitive values
      return [...new Set(fontsArray)];
    },
    getAllClassesOnLoadedFonts() {
      const fonts = this.getAllLoadedFonts();
      return fonts.map((font) => {
        const processedFontName = font.toLowerCase().replace(/[ "]/g, '');

        if (processedFontName === 'futurapt') return `${NAME_PREFIX}_futura-pt`;
        else if (processedFontName === 'poppins') {
          return `${NAME_PREFIX}_poppins`;
        } else if (processedFontName === 'rubik') return `${NAME_PREFIX}_rubik`;
      });
    },
    setSaleClasses() {
      this.saleClass = this.getSaleClass();
      this.allClassesOnLoadedFonts = this.getAllClassesOnLoadedFonts();
      this.saleAdditionalClasses = [];

      this.saleAdditionalClasses.push(
        `${NAME_PREFIX}_${this.isEmbedded ? 'embedded' : 'not-embedded'}`,
      );

      this.saleClasses = [
        this.saleClass,
        this.classes,
        ...this.saleAdditionalClasses,
        ...this.allClassesOnLoadedFonts,
      ];
    },
    setDuratuon() {
      const end = this.saleBlockData.endDate;
      const endDate = dayjs(end);

      const eternal = this.saleBlockData.isEternal;
      const timerMode = this.saleBlockData.unlimitedTimerMode;

      const curDate = dayjs();

      // Дата окончания заполнена
      if (end) {
        // Время истекло
        if (endDate < curDate) {
          // Скрыть баннер, остановить таймер
          clearInterval(this.interval);
          this.duration = dayjs.duration(0, 'milliseconds', true)
          return;
        }

        // Таймер не бесконечный - дата окончания на endDate
        if (!eternal) {
          const diff = dayjs(endDate).diff(curDate);
          this.duration = dayjs.duration(diff);
          return;
        }
      }

      // Таймер бесконечный - дата окончания на eternalEndDate
      // Если таймер бесконечный - не важно, заполнен ли endDate.
      if (eternal) {
        const eternalDateGetter = getEternalEndDate.bind(this);
        const eternalDateRaw = eternalDateGetter(timerMode);
        const eternalDate = dayjs(eternalDateRaw);
        const diff = dayjs(eternalDate).diff(curDate);
        this.duration = dayjs.duration(diff);
        return;
      }

      // Не может быть кейса, где !eternal и !endDate
      if (!eternal && !end) {
        console.error('"endDate" AND "eternal" not setted');
      }
    }
  },
};
